export type PopularPeriod = 'today' | '7d' | '28d' | '1y'

export const POPULAR_PERIODS: Array<{ id: PopularPeriod; label: string }> = [
  { id: 'today', label: 'Günlük' },
  { id: '7d', label: 'Haftalık' },
  { id: '28d', label: 'Aylık' },
  { id: '1y', label: 'Yıllık' },
]

export const POPULAR_PERIOD_LABEL: Record<PopularPeriod, string> = {
  today: 'Bugün',
  '7d': 'Son 7 gün',
  '28d': 'Son 28 gün',
  '1y': 'Son 1 yıl',
}

export function parsePopularPeriod(raw?: string | null): PopularPeriod {
  if (raw === 'today' || raw === 'gunluk') return 'today'
  if (raw === '28d' || raw === 'aylik') return '28d'
  if (raw === '1y' || raw === '365d' || raw === 'yillik') return '1y'
  if (raw === '7d' || raw === 'haftalik') return '7d'
  return '7d'
}

export function popularPeriodHref(path: string, period: PopularPeriod): string {
  return period === '7d' ? path : `${path}?period=${period}`
}
